"use strict";
/// <reference types="jquery"/>

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Plugins jQuery
 */
require("select2/dist/js/i18n/fr");
$.extend($.fn.select2.defaults.defaults, {
    theme: "bootstrap"
});
$.extend($.fn.datetimepicker.defaults, {
    icons: {
        time: "fa fa-clock-o",
        date: "fa fa-calendar",
        up: "fa fa-chevron-up",
        down: "fa fa-chevron-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fa fa-dot-circle-o",
        clear: "fa fa-trash",
        close: "fa fa-times"
    },
    locale: "fr"
});
$.unflatten = function (data) {
    var result = {};
    for (var i in data) {
        var keys = i.split(".");
        keys.reduce(function (r, e, j) {
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 === j ? data[i] : {} : []);
        }, result);
    }
    return result;
};
$.groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};
/**
* Récupère l'extension du fichier
*/
$.getFileExtension = function (fileName) {
    var splitUrl = !fileName ? [] : fileName.split(".");
    return splitUrl.length <= 1 ? "file" : splitUrl[splitUrl.length - 1].toLowerCase();
};
/**
* Récupère la class fa correspondante à l'extension du fichier
*/
$.getFileExtensionCss = function (fileName) {
    return "fa-" + $.getCssForExtension($.getFileExtension(fileName));
};
/**
* Retourne la class fa en fonction de l'extension du fichier
*/
$.getCssForExtension = function (extension) {
    switch (extension) {
        case "pdf":
            return "file-pdf-o";
        case "jpg":
        case "jpeg":
        case "png":
        case "bmp":
        case "gif":
            return "file-image-o";
        case "doc":
        case "docx":
            return "file-word-o";
        case "xls":
        case "xlsx":
            return "file-excel-o";
        case "ppt":
        case "pttx":
            return "file-powerpoint-o";
        case "csv":
            return "file-text-o";
        case "xml":
        case "sql":
        case "cs":
        case "cshtml":
        case "html":
        case "htm":
        case "xhtml":
            return "file-code-o";
        case "7z":
        case "zip":
        case "rar":
        case "gz":
        case "tgz":
            return "file-archive-o";
        case "link":
            return "link";
        default:
            return "file-o";
    }
    //TODO finir l'alimentation du type de fichier
};
$.downloadAjax = function (options) {
    $.ajax({
        url: options.url,
        type: options.method || "post",
        dataType: "binary",
        data: options.data,
        xhrFields: {
            responseType: "arraybuffer"
        },
        beforeSend: function beforeSend(jqXHR, a) {
            if (options.progress) {
                jqXHR.progress(options.progress);
            }
        }
    }).done(function (data, d, r) {
        var mimeType = r.getResponseHeader("Content-Type");
        var disposition = r.getResponseHeader("Content-Disposition");
        var filename = "";
        if (disposition) {
            var matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }
        var blob = new Blob([data], {
            type: mimeType
        });
        var link = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 100);
        if (options.done) {
            debugger;
            try {
                options.done();
            } catch (_a) {}
        }
    });
};
$.fn.extend({
    serializeObject: function serializeObject() {
        var o = {};
        var a = this.serializeArray();
        var elements = this.get(0).elements;
        $.each(a, function () {
            var serialized = elements && elements[this.name] && $(elements[this.name]).data("serialized");
            var value = this.value || "";
            if (serialized) {
                try {
                    value = JSON.parse(value);
                } catch (e) {}
            }
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(value);
            } else {
                o[this.name] = value;
            }
        });
        $.each(o, function (key, val) {
            if (val.push && $("[name='" + key + "']").data("force-string")) {
                o[key] = val.join(",");
            }
        });
        return o;
    },
    intuitiveSerializeObject: function intuitiveSerializeObject() {
        var o = $(this).serializeObject();
        return $.unflatten(o);
    },
    serializeJSONObject: function serializeJSONObject(intuitif) {
        if (intuitif === void 0) {
            intuitif = false;
        }
        return JSON.stringify(intuitif ? this.intuitiveSerializeObject() : this.serializeObject());
    },
    /**
     * Submit un formulaire en Ajax
     *
     * @returns this
     */
    submitAjax: function submitAjax() {
        var form = $(this),
            optionAjax = {
            type: form.attr("method"),
            url: form.attr("action")
        };
        form.find("textarea").each(function () {
            var cm = $(this).data("emmet-editor");
            if (cm) {
                cm.save();
            }
        });
        if (form.attr("enctype") && form.attr("enctype") === "multipart/form-data") {
            var fd = new FormData(form.get(0));
            if ("documentMode" in document || /Edge/.test(navigator.userAgent)) {
                form.find("input[type='file']").each(function () {
                    var input = this;
                    // Propriété créée pour Edge
                    var files = this["__files"];
                    if (files && files.length) {
                        $.each($.makeArray(files), function () {
                            fd.append(input.name, this);
                        });
                    }
                });
            }
            optionAjax.contentType = false;
            optionAjax.processData = false;
            optionAjax.data = fd;
        } else {
            if (form.data("intuitive-serialize")) {
                optionAjax.data = form.intuitiveSerializeObject();
            } else {
                optionAjax.data = form.serialize();
            }
        }
        $.ajax(optionAjax).done(function (data) {
            form.trigger("form.submit.done", [data]);
        }).fail(function (data) {
            form.trigger("form.submit.fail", [data]);
        });
        return this;
    },
    /**
     *  BootTree Treeview plugin for Bootstrap.
     *
     *  Based on BootSnipp TreeView Example by Sean Wessell
     *  URL: http://bootsnipp.com/snippets/featured/bootstrap-30-treeview
     *
     *  Revised code by Leo "LeoV117" Myers and by Fabien Ménager
     */
    treeview: function treeview() {
        return this.each(function () {
            // Initialize the top levels;
            var tree = $(this);
            tree.addClass("treeview-tree");
            tree.find("li").each(function () {
                var branch = $(this);
                if (branch.has("ul").length === 0) {
                    branch.addClass("tree-leaf");
                    return;
                }
                //li with children ul
                branch.prepend("<i class='tree-indicator fa fa-chevron-right fa-fw'></i>");
                branch.addClass("tree-branch");
                branch.on("click", function (e) {
                    if (this === e.target) {
                        var icon = $(this).children("i.tree-indicator");
                        icon.toggleClass("fa-chevron-down fa-chevron-right");
                        $(this).children("ul").toggle();
                    }
                });
                branch.children("ul").toggle();
                /**
                 * The following snippet of code enables the treeview to
                 * function when a button, indicator or anchor is clicked.
                 *
                 * It also prevents the default function of an anchor and
                 * a button from firing.
                 */
                branch.children(".tree-indicator, b, button, a.toggle").click(function (e) {
                    branch.click();
                    e.preventDefault();
                });
            });
            //Ouvrir la racine d'l'arbre si demandé...
            var openRoot = tree.data("open-root");
            if (openRoot && typeof openRoot !== "boolean") {
                openRoot = tree.data("open-root");
            }
            if (openRoot) {
                tree.find("> li").click();
            }
        });
    }
});
$(function () {
    /**
     * The following snippet of code automatically converst
     * any '.treeview' DOM elements into a treeview component.
     */
    $(".treeview").treeview();
    /**
     * Cmportement des boutons avec un formaction de type button
     */
    $("button[formaction][type=button][data-submit]").click(function () {
        var $button = $(this);
        var $form = $button.parents("form");
        $form.attr("action", $button.attr("formaction"));
        $form.submit();
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Addons/jquery-addons.ts
// module id = 511
// module chunks = 0